// Third-Party
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Internal
import { endAddingAccount, isAddingAccount } from "src/common/accountSession";
import useLocales from "src/hooks/useLocales";
import { PATH_DASHBOARD } from "src/routes/paths";

export default function AddAccountBackButton() {
  const { translate } = useLocales();
  const navigate = useNavigate();
  if (!isAddingAccount()) return null;
  return (
    <Button
      size="small"
      color="inherit"
      startIcon={<ArrowLeft size={16} />}
      sx={{ alignSelf: "flex-start", ml: -1 }}
      onClick={() => {
        endAddingAccount();
        navigate(PATH_DASHBOARD.root, { replace: true });
      }}
    >
      {translate("multi_account.go_back")}
    </Button>
  );
}
